module.exports = __webpack_public_path__ + "static/media/executive.3d00ba71.pdf";